import { useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Legend } from '../../../../../common/chart/legend'
import { PieChartContainer } from '../../../../../common/chart/pieChart'
import { Notification } from '../../../../../common/notification'
import { getUnique } from '../../../../../helpers/common'
import { valToPercent } from '../../../../../helpers/value'
import { filterTable, resetTable, selectData } from '../store/slice'
import { TitleChart } from './TitleChart'
import { TopCompaniesQuantity } from './TopCompaniesQuantity'
import classes from './index.module.scss'

const CHART_COLORS = [
  '#3DA967',
  '#E03643',
  '#EC626D',
  '#9C9C9C',
  '#D375AE',
  '#F58B00',
  '#3A414B',
  '#C8781A',
  '#E8B714',
]

export const BusinessStatusPieChart = ({ isDynamicReport }) => {
  const dispatch = useDispatch()
  const chartId = useRef(getUnique())
  const [previousName, setPreviousName] = useState()

  const data = useSelector(selectData)

  const chartData = Object.values(data).map((item, index) => {
    return {
      name: item.activeStatusName,
      value: item.totalPercentCompanies,
      color: CHART_COLORS[index],
    }
  })

  const onPieClick = ({ name }) => {
    if (name !== previousName) {
      dispatch(filterTable(name))
      setPreviousName(name)
    } else {
      dispatch(resetTable())
      setPreviousName('')
    }
  }

  if (!Object.keys(data).length && isDynamicReport) {
    return <Notification isDynamicReport={isDynamicReport} />
  }

  return (
    <div className={classes.container}>
      <PieChartContainer
        chartId={chartId.current}
        data={chartData}
        formatValueTooltip={(val, { locale }) => valToPercent(val, locale)}
        innerRadius={40}
        isLabelActive={false}
        labelCenter={{
          customLabel: () => <TopCompaniesQuantity />,
          outerRadius: '50%',
        }}
        width={160}
        height={160}
        onPieClick={onPieClick}
      />
      <div className="flexColumn gap1">
        <TitleChart
          title="industryOverview.businessStatus.OPERATING_STATUS"
          isI18n
        />

        <Legend
          className="flexColumn"
          chartId={chartId.current}
          items={chartData.map((item, index) => ({
            title: item.name,
            color: item.color,
            pieIndex: index,
          }))}
        />
      </div>
    </div>
  )
}
